import { Link } from "react-scroll";
import "./index.scss";

const Nav = ({ children }) => {
  return (
    <nav>
      {children}
      <ul>
        <Link
          to="header"
          activeClass="active-nav"
          spy={true}
          smooth={true}
          offset={0}
          duration={500}
        >
          About
        </Link>
        <Link
          to="services"
          activeClass="active-nav"
          spy={true}
          smooth={true}
          offset={40}
          duration={500}
        >
          Services
        </Link>
        <Link
          to="works"
          activeClass="active-nav"
          spy={true}
          smooth={true}
          offset={20}
          duration={500}
        >
          Works
        </Link>
        {/* <Link
          to="blog"
          activeClass="active-nav"
          spy={true}
          smooth={true}
          offset={50}
          duration={500}
        >
          Blog
        </Link> */}
      </ul>
    </nav>
  );
};

export default Nav;
